/**
 * InfoBoxCriteria
 */
import clsx from 'clsx';
import React from 'react';
/** Main description for this component. */
var InfoBoxCriteria = function (_a) {
    var id = _a.id, className = _a.className, heading = _a.heading, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h2' : _b, children = _a.children;
    var Heading = headingLevel;
    return (React.createElement("div", { "data-cid": "InfoBoxCriteria", className: clsx(className, 'bg-greyLight px-6 py-16'), id: id },
        React.createElement(Heading, { className: "mb-4 text-h2 font-bold flex justify-between" }, heading),
        children));
};
export default InfoBoxCriteria;
